import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routesPC = [
  {
    path: '/',
    redirect: 'aboutUs'
  },
  {
    path: '/aboutUs',
    name: 'aboutUs',
    component: () => import('@/views/aboutUs/index.vue')
  },
  {
    path: '/fundProduct',
    name: 'fundProduct',
    component: () => import('@/views/fundProduct/index.vue')
  },
  {
    path: '/news',
    name: 'news',
    component: () => import('@/views/news/index.vue')
  },
  {
    path: '/newsDetails',
    name: 'newsDetails',
    component: () => import('@/views/news/components/newsDetails.vue')
  },
  {
    path: '/investorInteraction',
    name: 'investorInteraction',
    component: () => import('@/views/investorInteraction/index.vue')
  },
  {
    path: '/contactUs',
    name: 'contactUs',
    component: () => import('@/views/contactUs/index.vue')
  }
]
const routesMobile = [
  {
    path: '/',
    redirect: 'aboutUs'
  },
  {
    path: '/aboutUs',
    name: 'aboutUs',
    component: () => import('@/mobilePage/aboutUs/index.vue')
  },
  {
    path: '/fundProduct',
    name: 'fundProduct',
    component: () => import('@/mobilePage/fundProduct/index.vue')
  },
  {
    path: '/news',
    name: 'news',
    component: () => import('@/mobilePage/news/index.vue')
  },
  {
    path: '/newsDetails',
    name: 'newsDetails',
    component: () => import('@/mobilePage/news/components/newsDetails.vue')
  },
  {
    path: '/investorInteraction',
    name: 'investorInteraction',
    component: () => import('@/mobilePage/investorInteraction/index.vue')
  },
  {
    path: '/contactUs',
    name: 'contactUs',
    component: () => import('@/mobilePage/contactUs/index.vue')
  }
]

const isMobile = window.matchMedia('(max-width: 767px)').matches
const routes = isMobile ? routesMobile : routesPC
const router = new VueRouter({ routes })
export default router
